import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import Card from "components/Card";
import { Grid } from "components/Containers";
import { Label, Select, TextInput } from "components/Form";
import { AdvancedFilters } from "components/AdvancedFilters";
import { DIRECTION, NETWORK_LIST_FILTERS_CONFIG, STICKY_NETWORK_FILTER_KEYS } from "constants/index";
import { toUcFirst } from "utils";

/**
 * NetworkListControls
 *
 * @param {Boolean}    hideAdvancedFilters
 * @param {Boolean}    hideKeywordSearch
 * @param {Boolean}    hideSorts
 * @param {Function}   handleSearchInputChange
 * @param {Object}     state
 * @param {Function}   setState
 * @param {String}     keyword
 * @param {Boolean}    hasKeywordSearch
 * @param {Array}      sortingOptions
 */
const NetworkListControls = ({
  hideAdvancedFilters = false,
  hideKeywordSearch = false,
  hideSorts = false,
  handleSearchInputChange,
  state,
  setState,
  keyword,
  hasKeywordSearch,
  sortingOptions,
  ...props
}) => {
  if (hideAdvancedFilters && hideKeywordSearch && hideSorts) return null;

  const { sortKey, sortDirection } = state;

  return (
    <Card>
      <Grid>
        {!hideKeywordSearch && (
          <Grid.col colSpan={3}>
            <Label>
              <FormattedMessage id="Global.KeywordSearch.Label" />
            </Label>
            <TextInput
              name="keyword"
              value={keyword}
              placeholder="Search by keyword"
              maxLength={50}
              onChange={(_, val) => handleSearchInputChange(val)}
            />
          </Grid.col>
        )}
        {!hideSorts && (
          <>
            <Grid.col colSpan={3}>
              <Label>
                <FormattedMessage id="Global.SortBy" />
              </Label>
              <Select
                name="sortKey"
                value={sortKey}
                options={sortingOptions}
                placeholder="Sort by"
                onChange={(name, val) => setState((prev) => ({ ...prev, [name]: val }))}
                isClearable={false}
                disabled={hasKeywordSearch}
              />
            </Grid.col>
            <Grid.col colSpan={3}>
              <Label>
                <FormattedMessage id="Global.SortDirection" />
              </Label>
              <Select
                name="sortDirection"
                value={sortDirection}
                options={Object.entries(DIRECTION).map(([label, value]) => ({ label: toUcFirst(label), value }))}
                onChange={(name, val) => setState((prev) => ({ ...prev, [name]: val }))}
                isClearable={false}
                disabled={hasKeywordSearch}
              />
            </Grid.col>
          </>
        )}
      </Grid>
      {!hideAdvancedFilters && (
        <AdvancedFilters
          selected={state}
          setSelected={setState}
          filterConfigMap={NETWORK_LIST_FILTERS_CONFIG}
          initialStickyFilterKeys={STICKY_NETWORK_FILTER_KEYS}
          {...props}
        />
      )}
    </Card>
  );
};

NetworkListControls.propTypes = {
  hideAdvancedFilters: PropTypes.bool,
  hideKeywordSearch: PropTypes.bool,
  hideSorts: PropTypes.bool,
  handleSearchInputChange: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  keyword: PropTypes.string.isRequired,
  hasKeywordSearch: PropTypes.bool,
  sortingOptions: PropTypes.array,
};

export default NetworkListControls;
